import { useState } from "react";
import { Col, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Home, Href, Profile, TemplateTabAndContentTitle } from "../../../../Constants/Constants";

const TemplateTabAndContent = () => {
  const [basicTab, setBasicTab] = useState("1");

  return (
    <Col md="6" sm="12">
      <div className="element-card">
        <div className="element-card-header heading">
          <h2>{TemplateTabAndContentTitle}</h2>
        </div>
        <div className="element-card-body typography">
          <div className="template-tab">
            <Nav tabs>
              <NavItem>
                <NavLink href={Href} className={`txt-primary ${basicTab === "1" ? "active" : ""}`} onClick={() => setBasicTab("1")}>
                  {Home}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href={Href} className={`txt-primary ${basicTab === "2" ? "active" : ""}`} onClick={() => setBasicTab("2")}>
                  {Profile}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={basicTab}>
              <TabPane className={`fade button-effect fade ${basicTab === "1" ? "show" : ""}`} tabId={"1"}>
                {Home}
              </TabPane>
              <TabPane className={`button-effect fade ${basicTab === "2" ? "show" : ""}`} tabId={"2"}>
                {Profile}
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default TemplateTabAndContent;
